/** @see https://developers.google.com/search/docs/crawling-indexing/block-indexing */
export function noindex() {
  return {
    content: 'noindex',
    name: 'robots',
  };
}
